import { Locale } from "../schema/Locale.js";

export function localizePathFromData(path: string, locale: Locale): string {
	switch (locale) {
		case Locale.cs:
			return `/${path}`;
		case Locale.en:
			return `/${locale}/${path}`;
		case Locale.sk:
			return `/${locale}/${path}`;
		default:
			return `/${path}`;
	}
}
